import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const BankWireStyles = () => {
  const theme = useTheme();
  return {
    content: {
      heading: {
        color: theme.palette.grey[900],
      },
      actionBtn: {
        width: "240px",
      },
      infoWrapper: {
        background: theme.palette.grey[100],
        p: 3,
        my: 2,
        borderRadius: "8px",
      },
      infoLabel: {
        minWidth: "90px",
      },
      infoValue: (highlighted: boolean) => ({
        color: theme.palette.grey[900],
        lineHeight: 0.6,
        ...(highlighted
          ? {
              border: `2px solid ${theme.palette.success.main}`,
              padding: "4px",
              borderRadius: "4px",
            }
          : {}),
      }),
      infoSubValue: {
        padding: "-8px",
      },
    },
  };
};
